import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-carousel',
  imports: [RouterLink],
  templateUrl: './carousel.html',
  styleUrl: './carousel.scss'
})
export class Carousel {

  ngOnInit(): void {
    this.initCarousel();
  }

  ngOnDestroy(): void {
    // Nettoyer les événements
    const carouselElement = document.getElementById('carousel');
    if (carouselElement) {
      carouselElement.removeEventListener('slide.bs.carousel', this.updateIndicators);
    }
  }

  initCarousel(): void {
    const carouselElement = document.getElementById('carousel');
    const indicators = document.querySelectorAll('.hero-indicators button');

    if (carouselElement && indicators.length > 0) {
      // Écouter les changements de slide
      carouselElement.addEventListener('slide.bs.carousel', (event: any) => {
        // Retirer la classe active de tous les indicateurs
        indicators.forEach(indicator => {
          indicator.classList.remove('active');
          indicator.removeAttribute('aria-current');
        });

        // Ajouter la classe active à l'indicateur correspondant
        const activeIndicator = indicators[event.to];
        if (activeIndicator) {
          activeIndicator.classList.add('active');
          activeIndicator.setAttribute('aria-current', 'true');
        }
      });
    }
  }

  updateIndicators = (event: any) => {
    const indicators = document.querySelectorAll('.hero-indicators button');
    indicators.forEach(indicator => {
      indicator.classList.remove('active');
      indicator.removeAttribute('aria-current');
    });
    const activeIndicator = indicators[event.to];
    if (activeIndicator) {
      activeIndicator.classList.add('active');
      activeIndicator.setAttribute('aria-current', 'true');
    }
  }
}
